import utils from '@/common/util/utils'
import {
  IS_PRODUCTION_MODE,
  URL_COOKIE_DOMAIN,
  SERVICE_LOCATION_KEY,
  API_BASE_AZURE_URL,
  API_BASE_URL,
  PAYMENT_GATE_TYPE_ONE_STORE,
  PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE, PRODUCT_TYPE_PRODUCT
} from '@/common/constant'
import { stringify, parseUrl } from 'query-string'
import { isNil, get } from 'lodash'
import { knock, UserService } from '@/common/api/api.service'
import { EventBus } from '@/components/eventbus/EventBus'
import { getEventListByType } from '@/common/util/event.util'
import { ON_CLICK } from '@/common/event.const'
import router from '@/router'
import store from '@/store'
import { SET_CURRENT_MENU } from '@/store/types/mutations.type'
import { FETCH_MULTI_BANNER_LIST_INFO } from '@/store/types/actions.type'
import {
  PATH_NAME_LIST,
  DISABLE_BOTTOM_TAB_ROUTE_NAME_LIST,
  PATH_NAME_INSTANTPLAY_LIST,
  PATH_NAME_ALARM_NOTICE_LIST,
  PATH_NAME_LNB_USER_INFO, PATH_NAME_LNB_EDIT_USER_PROFILE, PATH_NAME_LNB_EDIT_USER_ONE_OF_PROFILE
} from '@/common/router.const'
import { DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS } from '@/common/devicetype.const'
export const getTypeCodeFromTitleString = (title) => {
  switch (title) {
    case '프로그램':
      return 'program'
    case 'VOD':
      return 'vod'
    case 'LIVE':
      return 'live'
    case '영화':
      return 'movie'
    case 'TV컷':
      return 'clip'
    case '에디터Pick':
      return 'theme'
    case '고객지원':
      return 'faq'
    case '영화플러스':
      return 'movie'
  }
}
const getCookieExpireDate = () => {
  const expires = new Date()
  expires.setHours(0, 0, 0, 0)
  expires.setDate(expires.getDate() + 365)
  return expires
}
const getOneYearExpireUTCString = () => getCookieExpireDate().toUTCString()
const isSaveUserID = (saveId) => !isNil(saveId) && saveId
export const saveIdProcess = ({ saveId = false, userId }) => {
  if (isSaveUserID(saveId)) {
    utils.cookies.setItem('userId', userId, getOneYearExpireUTCString(), URL_COOKIE_DOMAIN, '/')
  } else {
    utils.cookies.removeItem('userId', URL_COOKIE_DOMAIN, '/')
  }
}
export const isPreRenderer = () => {
  return get(window, ['__PRERENDER_INJECTED', 'isPreRender'], '') === 'y'
}
export const setAutoLoginInfo = ({ autoLogin, credential }) => {
  if (autoLogin) {
    utils.cookies.setAutoLoginCredential(credential)
  }
}
const isPooqDomain = location.href.indexOf('m.pooq.co.kr') > -1
const isWavveDomain = location.href.indexOf('m.wavve.com') > -1
const isRootPath = location.pathname === '/' || location.pathname === '/index' || location.pathname === '/index.html'
const isProduction = process.env.NODE_ENV === 'production'

export const autoLoginTransfer = () => {
  if (isPreRenderer()) return
  const protocol = isProduction ? 'https://' : 'http://'
  const has = some => some !== 'none'
  const savedUserId = utils.cookies.getSaveUserId()
  const savedCredential = utils.cookies.getAutoLoginCredential() || 'none'
  const isAutoLoginPath = location.pathname === '/autologin'
  if (isPooqDomain && isRootPath) {
    if (has(savedUserId) || has(savedCredential)) {
      let url = `${protocol}m.wavve.com/autologin?`
      const queryParam = {}
      if (has(savedUserId)) {
        queryParam.userid = savedUserId
        utils.cookies.removeItem('userId', URL_COOKIE_DOMAIN, '/')
      }
      if (has(savedCredential)) {
        queryParam.key = `${decodeURIComponent(savedCredential).replace(/"/gi, '')}`
        utils.cookies.removeItem('cs', URL_COOKIE_DOMAIN, '/')
        utils.cookies.removeItem('credential', URL_COOKIE_DOMAIN, '/')
      }
      location.replace(`${url}${stringify(queryParam)}`)
    } else {
      const domain = `${protocol}m.wavve.com`
      location.replace(domain)
    }
  } else if (isWavveDomain && isAutoLoginPath) {
    const { query } = parseUrl(location.href)
    const credential = get(query, 'key', '')
    try {
      if (credential !== '') {
        UserService.login({ type: 'credential', id: credential, pushid: '', password: '', profile: '' }, () => {
          alert('자동 로그인에 실패 했습니다.')
          location.replace(`${protocol}m.wavve.com`)
        })
          .then((response) => {
            let responseArray = Object.assign({ isPooqZone: false }, response.data)
            utils.cookies.setItem('cs', JSON.stringify(responseArray), null, URL_COOKIE_DOMAIN, '/')
            utils.cookies.setAutoLoginCredential(response.data.credential)
            window.location.reload(true)
          })
      }
    } catch (e) {
      location.replace(`${protocol}m.wavve.com`)
    }
  } else {
    utils.redirectWithParams()
  }
}

const hasProtocol = url => url.substring(0, 4) === 'http'
const prependProtocol = url => location.protocol + '//' + url

export const bannerLink = (targetUrl) => {
  if (targetUrl.indexOf('captvpooq://purchasewebview') > -1) {
    const { query } = parseUrl(targetUrl)
    let cancelUrl = window.location.origin + '/callback.html?action=Cancel'
    utils.common.showBillingPopup({ productId: query.productId, productType: 'all', returnUrl: 'https://m.wavve.com', canceledUrl: cancelUrl })
  } else if (targetUrl.substring(0, 9) === 'captvpooq') {
    utils.common.checkInstallApps(targetUrl.replace('captvpooq://', ''))
  } else {
    const { url, query } = parseUrl(targetUrl)
    const hasWavveDomain = url.indexOf('wavve.com') > -1
    const hasPooqDomain = url.indexOf('pooq.co.kr') > -1
    let newUrl = hasProtocol(url) ? url : prependProtocol(url)
    if (hasWavveDomain || hasPooqDomain) {
      if (url.indexOf('member.wavve.com') > -1) {
        newUrl = newUrl.replace('http://', 'https://')
      }
      newUrl = newUrl.replace('pooq.co.kr', 'wavve.com').replace('www.wavve.com', 'm.wavve.com')
      if (IS_PRODUCTION_MODE) {
        location.href = newUrl + '?' + stringify(query)
      } else {
        location.href = newUrl.replace('m.wavve.com', location.host) + '?' + stringify(query)
      }
    } else {
      if (IS_PRODUCTION_MODE) {
        location.href = newUrl + '?' + stringify(query)
      } else {
        location.href = newUrl.replace('m.wavve.com', location.host) + '?' + stringify(query)
      }
    }
  }
}
export const removePrefixEmptyString = (string) => {
  const res = []
  const charList = string.split('')
  let removeComplete = false
  for (let i = 0, len = charList.length; i < len; i++) {
    if (charList[i] !== ' ') {
      removeComplete = true
    }
    if (removeComplete) {
      res.push(charList[i])
    }
  }
  return res.join('')
}

// export const bannerLink = (url) => {
//   url = url.replace('www.pooq.co.kr', '').replace('m.pooq.co.kr', '')
//   const { query } = parseUrl(url)
//   const device = utils.cookies.getDevice()
//   const isInApp = device === 'ios' || device === 'android'
//   const hasProtocol = pUrl => pUrl.substring(0, 4) === 'http'
//   const protocol = isProduction ? 'https://' : 'http://'
//   const hasDomain = url.indexOf('wavve.com') > -1
//   if (isInApp) { // webview 일때는 captvpooq:// 으로 내려옴
//     location.href = url
//   } else {
//     if (url.indexOf('purchasewebview') > -1) {
//       utils.common.showBillingPopup(query.productId, 'all', 'https://m.wavve.com')
//     } else {
//       if (url.indexOf('member.wavve.com') > -1) {
//         location.href = 'https://' + url
//       } else {
//         let urlWithDomain = hasDomain ? url : location.origin + url
//         urlWithDomain = urlWithDomain.replace('www.', 'm.')
//         urlWithDomain = hasProtocol(urlWithDomain) ? urlWithDomain : protocol + urlWithDomain
//         location.href = urlWithDomain
//       }
//     }
//   }
// }
//
// export const checkPremierPromotion = () => {
//   if (isPreRenderer()) return
//   if (sessionStorage.getItem(CONFIRM_EMERGENCY) === 'y') return
//   const premierPathList = [
//     '/event/premier12/2019/index.html',
//     '/event/premier12/2019/index',
//     '/event/premier12/2019/premier_schedule.html',
//     '/event/premier12/2019/premier_schedule'
//   ]
//   const device = utils.cookies.getDevice()
//   if (device !== 'android' && device !== 'ios') {
//     const timeStamp = new Date().getTime()
//     axios.get(PREMIER_JSON + '?timeStamp=' + timeStamp).then(({ data }) => {
//       const isEmergency = get(data, ['emergency', 'use'], 'n') === 'y'
//       const isPremierPath = premierPathList.filter((premierPath) => premierPath === location.pathname).length > 0
//       const premierUrl = get(data, ['emergency', 'url'], '')
//       if (isEmergency && !isPremierPath) {
//         location.replace(premierUrl)
//       } else if (!isEmergency && isPremierPath) {
//         location.replace('/')
//       }
//     })
//   }
// }

export const androidPurchase = ({ productId, url, contentId = '', contentType = '' }) => {
  window.Android.clickPurchase(productId, url, contentId, contentType)
}
export const androidPromotionPurchase = ({ productId, promotionCode, url, contentId = '', contentType = '' }) => {
  window.Android.clickPurchase(productId, promotionCode, url, contentId, contentType)
}
export const androidOneStorePurchase = ({ productId, url, contentId = '', contentType = '', pgName }) => {
// export const androidOneStorePurchase = (params) => {
  window.Android.clickOneStorePurchase(productId, url, contentId, contentType, pgName)
}
export const androidGoogleStorePurchase = ({ productId, productTypeForGoogleIAP }) => {
  console.log('androidGoogleStorePurchase : productId : ' + productId)
  console.log('androidGoogleStorePurchase : prodcutType : ' + productTypeForGoogleIAP)
  window.Android.clickGooglePurchase(productTypeForGoogleIAP, productId)
}

export const voucherPurchase = ({ deviceType, productId, contentType = '', contentId = '', promotionCode = '', callbackAction = 'ClosePopupAndReload', canceledCallbackAction = 'Cancel', pgName = '', productTypeForGoogleIAP = '' }) => {
  const returnUrl = window.location.origin + '/callback.html?action=' + callbackAction
  const canceledUrl = window.location.origin + '/callback.html?action=' + canceledCallbackAction
  try {
    if (deviceType === DEVICE_TYPE_IOS) {
      window.webkit.messageHandlers.clickPurchase.postMessage(productId)
    } else if (deviceType === DEVICE_TYPE_ANDROID) {
      const url = encodeURIComponent(returnUrl)
      if (pgName === PAYMENT_GATE_TYPE_ONE_STORE) {
        androidOneStorePurchase({ productId, url, contentId, contentType, pgName })
      } else if (pgName === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE) {
        if (productTypeForGoogleIAP === PRODUCT_TYPE_PRODUCT) {
          androidPurchase({ productId, url, contentId, contentType })
        } else {
          androidGoogleStorePurchase({ productTypeForGoogleIAP, productId })
        }
      } else {
        if (promotionCode === '') {
          androidPurchase({ productId, url, contentId, contentType })
        } else {
          androidPromotionPurchase({ productId, url, contentId, contentType, promotionCode })
        }
      }
    } else {
      utils.common.showBillingPopup({ productId, productType: 'all', returnUrl, contentType, contentId, promotionCode, canceledUrl })
    }
  } catch (err) {
    console.log(err)
  }
}

export function comparePath (orgPath, checkPath) {
  let isCorrect = false
  if (orgPath === checkPath) return true
  const orgPathList = orgPath.split('/')
  const checkPathList = checkPath.split('/')
  if (orgPathList.length === checkPathList.length) {
    let isMatched = true
    let i = 0
    while (i < checkPathList.length) {
      if (!isMatched) break
      const orgPath = orgPathList[i]
      const checkPath = checkPathList[i]
      if (orgPath !== '{path}') {
        isMatched = orgPath === checkPath
      }
      i = i + 1
    }
    isCorrect = isMatched
  }
  return isCorrect
}

export function setServiceLocationInfo (serviceLocation) {
  sessionStorage.removeItem(SERVICE_LOCATION_KEY)
  sessionStorage.setItem(SERVICE_LOCATION_KEY, JSON.stringify(serviceLocation))
}

export function getServiceLocationInfo () {
  return JSON.parse(sessionStorage.getItem(SERVICE_LOCATION_KEY))
}

export function hasUserConfirmPPV () {
  return utils.cookies.isPpvConfirmUser()
}

export function getTitle (cell) {
  let title = ''
  get(cell, 'title_list', []).forEach((titleItem) => {
    title += ' ' + titleItem.text
  })
  return title
}

export function selectCell (cell) {
  const { onNavigationEvent, onClickEvent } = getEventListByType(get(cell, 'event_list', []))
  if (onClickEvent) {
    EventBus.$emit(ON_CLICK, onClickEvent)
  }
  const { url, query } = parseUrl(get(onNavigationEvent, 'url', '').replace('.html', ''))
  let newQuery = query
  let referer = location.pathname
  if (referer.indexOf('search') > -1) referer = referer + '?' + location.search
  newQuery.referer = referer
  let newUrl = url
  newUrl = newUrl.replace('https://', '')
  newUrl = newUrl.replace('http://', '')
  newUrl = newUrl.replace('m.pooq.co.kr', '')
  newUrl = newUrl.replace('www.pooq.co.kr', '')
  newUrl = newUrl.replace('www.wavve.com', '')
  newUrl = newUrl.replace('m.wavve.com', '')
  newUrl = newUrl.replace('.html', '')
  router.push(newUrl + '?' + stringify(newQuery))
}

export function WavveOnProfileImageInfo () {
  const wavveonType = utils.cookies.getPooqZoneType()
  switch (wavveonType) {
    case 'pcbang':
      return { image: 'ic-my-profile-pc.png', imageAlt: '피시방' }
    case 'library':
      return { image: 'ic-my-profile-library.png', imageAlt: '도서관' }
    case 'hospital':
      return { image: 'ic-my-profile-hospital.png', imageAlt: '병원' }
    case 'accommodations':
      return { image: 'ic-my-profile-stay.png', imageAlt: '숙박업소' }
    default :
      return { image: 'ic-my-profile-others.png', imageAlt: '그외 기타' }
  }
}

export function hasViewMore (sectionInfo) {
  return get(sectionInfo, 'viewMoreEvent', null) !== null
}

export function sectionInfoTitle (sectionInfo) {
  return get(sectionInfo, 'title', '')
}

export function viewMoreTitle (sectionInfo) {
  return get(sectionInfo, 'viewMoreEvent.title', '더보기')
}
const isApiUrl = (viewMoreUrl) => {
  let { url } = parseUrl(viewMoreUrl)
  url = url.replace('http://', '').replace('https://', '')
  const targetUrl = url.indexOf('/') > -1 ? url.split('/')[0] : url
  const API_URL_LIST = [API_BASE_URL, API_BASE_AZURE_URL]
  return API_URL_LIST.some((baseUrl) => {
    return baseUrl.replace('https://', '').indexOf(targetUrl) > -1
  })
}
const getUiCode = (viewMoreEvent, route) => {
  const { url, query } = parseUrl(viewMoreEvent.url)
  const uiCode = get(query, 'uitype', '')
  const hasUiCode = uiCode !== ''
  if (hasUiCode) {
    return uiCode
  } else {
    const uiParent = get(query, 'uiparent', '')
    const hasUiParent = uiParent !== ''
    if (hasUiParent) {
      return uiParent.indexOf('-') > -1 ? uiParent.split('-').pop() : url.split('/').pop()
    } else {
      return url.split('/').pop()
    }
  }
}
const getCustomQuery = (onViewMore, route) => {
  return {
    api: encodeURIComponent(get(onViewMore, 'url', '').replace('https://', '').replace('http://', '')),
    referer: get(route, 'fullPath', ''),
    came: get(route, 'name', '')
  }
}
export function routeToList (sectionInfo, route) {
  const isInstantPlay = get(sectionInfo, 'viewMoreEvent.url', '').indexOf('/instantplay/') > -1
  if (isApiUrl(get(sectionInfo, 'viewMoreEvent.url', ''))) {
    router.push({
      name: isInstantPlay ? PATH_NAME_INSTANTPLAY_LIST : PATH_NAME_LIST,
      params: {
        section: get(route, 'name', ''),
        url: get(sectionInfo, 'viewMoreEvent.url', ''),
        uiCode: getUiCode(get(sectionInfo, 'viewMoreEvent', {}), route)
      },
      query: getCustomQuery(get(sectionInfo, 'viewMoreEvent', {}), route)
    })
  } else {
    // TODO: 서버에 요청하여 새로운 규격 처리 해달라고 해야됨
    const { url, query } = parseUrl(get(sectionInfo, 'viewMoreEvent.url', ''))
    let newUrl = url
    newUrl = newUrl.replace('https://', '')
    newUrl = newUrl.replace('http://', '')
    newUrl = newUrl.replace('m.pooq.co.kr', '')
    newUrl = newUrl.replace('www.pooq.co.kr', '')
    newUrl = newUrl.replace('www.wavve.com', '')
    newUrl = newUrl.replace('m.wavve.com', '')
    newUrl = newUrl.replace('.html', '')
    router.push(newUrl + '?' + stringify(query))
  }
}
export function isEnableBottomTabView (routeName) {
  return DISABLE_BOTTOM_TAB_ROUTE_NAME_LIST.indexOf(routeName) === -1
}
export function sendKnock () {
  const KNOCK_TRACE_KEY = 'knock_trace_key'
  const isMobileWeb = utils.cookies.getDevice() === 'mobile'
  if (isMobileWeb && utils.cookies.getItem(KNOCK_TRACE_KEY) !== 'knock') {
    knock().then(() => {
      utils.cookies.setItem(KNOCK_TRACE_KEY, 'knock')
    })
  }
}
let debounce
export function mainBeforeEnter (to, from, next) {
  if (to.path.indexOf('index.html') > -1) {
    next(to.path.replace('/index.html', ''))
  }
  store.commit(SET_CURRENT_MENU, to.name)
  next()
  store.dispatch(FETCH_MULTI_BANNER_LIST_INFO, { menuName: to.name }).then(() => {
  })
  if (debounce) {
    clearTimeout(debounce)
  }
}
export const isApp = () => {
  const appList = [DEVICE_TYPE_ANDROID, DEVICE_TYPE_IOS]
  return appList.indexOf(utils.cookies.getDevice()) !== -1
}
